/**
 * External Dependencies
 */
import 'jquery';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import templateOffer from './routes/template-offer'; 

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  //Font Page
  home,
  // Template Offer
  templateOffer, 
});

// jQuery(document).ready(() => routes.loadEvents());

window.onload = () => {
  routes.loadEvents();
}
